var _defs, _path, _circle, _path2;
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTaskShared24(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#009AD9;}"))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "TaskShared_24") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M15,19a2,2,0,0,0-.88.21L8,15.12s0-.06,0-.09l6-3.32A2,2,0,0,0,15,12a2,2,0,1,0-2-2L7,13.29A2,2,0,0,0,6,13a2,2,0,1,0,.88,3.79L13,20.88S13,21,13,21a2,2,0,1,0,2-2Z"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 6,
    cy: 15,
    r: 2
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M19.35,7a7.49,7.49,0,0,0-14-2A6,6,0,0,0,0,11a4.49,4.49,0,0,0,0,.64.88.88,0,0,0,0,.17c0,.16.05.31.08.46s0,.11,0,.17.08.3.13.44a.78.78,0,0,0,0,.14,4.37,4.37,0,0,0,.18.46l0,.08c.08.17.17.33.26.49l0,0A6,6,0,0,0,2.05,15.5,4.23,4.23,0,0,1,2,15a3.91,3.91,0,0,1,.56-2,3.7,3.7,0,0,1-.36-.81c0-.07-.05-.14-.07-.22l-.06-.3A3.71,3.71,0,0,1,2,11,4,4,0,0,1,6,7h.71A5.5,5.5,0,0,1,12,3a5.32,5.32,0,0,1,1.07.11h0a5.18,5.18,0,0,1,1,.3h0a4.85,4.85,0,0,1,.9.48h0a4.91,4.91,0,0,1,.79.64h0a5.44,5.44,0,0,1,1.66,3.77c0,.06,0,.11,0,.17V9H19a3,3,0,0,1,0,6H11.42l3,2H19a5,5,0,0,0,.35-10Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTaskShared24);
export default __webpack_public_path__ + "static/media/TaskShared_24.4f0f1b0dcc94b6a26316b488398aea53.svg";
export { ForwardRef as ReactComponent };